import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import {GetCategoryTemplate, GetClientAll} from '../../../store/constants'

export default () => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiUrl2 + '/config-category-template-fb';
    var paramBody = {
        "data":{
            "idcategory":[""],
        }
    };
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await fetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('data');
    }
    dispatch({ type: GetCategoryTemplate, data: fromJS(data) });
};